import type { DefaultValues, SubmitHandler } from 'react-hook-form';
import { forwardRef } from 'react';

import type { IContentBlockFormBodyProps } from '~/components/molecules/ContentBlock';
import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { IFileUploaderValue } from '~/components/organisms/fields/FileUploader';
import { usePersistentForm } from '~/components/utils/PersistentForm';
import { useFormAutoFocus } from '~/hooks/useFormAutoFocus';
import { AppFormMainSection } from './AppFormMainSection';

export type IAppFormValues = {
  name: string;
  themeColorPrimary?: string;
  organizationId?: string;
  icons?: Array<IFileUploaderValue>;
};

export type IAppFormProps = IContainerProps &
  Omit<
    IContentBlockFormBodyProps<IAppFormValues>,
    'form' | 'children' | 'onSubmit' | 'submitting'
  > & {
    mode: IFormMode;
    defaultValues?: DefaultValues<IAppFormValues>;
    onSubmit?: SubmitHandler<IAppFormValues>;
    appId?: string;
  };

export const AppForm = forwardRef<HTMLFormElement, IAppFormProps>(
  function AppForm(props, ref) {
    const { sx, mode, defaultValues, onSubmit, appId, ...other } = props;
    const form = usePersistentForm<IAppFormValues>({
      defaultValues,
    });
    useFormAutoFocus({ form, name: 'name' });

    return (
      <ContentBlock.FormBody
        ref={ref}
        sx={sx}
        form={form}
        onSubmit={onSubmit}
        {...other}
      >
        <AppFormMainSection form={form} mode={mode} appId={appId} />
      </ContentBlock.FormBody>
    );
  },
);
